export default "__VITE_PUBLIC_ASSET__0d4fd9c0__"